"use client";

import { getIsRobot } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getIsRobot";
import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import { useShouldShowSEOLanguageSelector } from "@faire/marketplace-lib/stores/retailer/useShouldShowSEOLanguageSelector";
import { getBrowserLevelLanguageAndLocaleKey } from "@faire/marketplace-lib/stores/user/utils";
import { useQuery as useQueryLocalizationInfo } from "@faire/web-api--source/endpoints/www/api/page-data/localization-info/get-hooks";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import React, { Suspense } from "react";

import { LazyLanguageSelector } from "../../LanguageSelector/LazyLanguageSelector";
import { HeaderLine } from "../styled";

export const LanguageSelectorSection = () => {
  const showSEOLanguageSelector = useShouldShowSEOLanguageSelector();
  const user = getUser();
  const { browserLevelLanguage, browserLevelLocaleKey } =
    getBrowserLevelLanguageAndLocaleKey(user);

  const { data: localizationInfo } = useQueryLocalizationInfo();
  const availableLanguageSelectorLocales =
    localizationInfo?.available_language_selector_locales ?? [];
  const showLanguageSelector =
    !getIsRobot() &&
    localizationInfo &&
    localizationInfo.session_country !== THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;

  return showLanguageSelector || showSEOLanguageSelector ? (
    <>
      <Suspense fallback={<div className="h-[60px] w-[90px]" />}>
        <LazyLanguageSelector
          eventKey="logged-out-top"
          browserLanguage={browserLevelLanguage as Language}
          browserLocale={browserLevelLocaleKey}
          availableLocales={availableLanguageSelectorLocales}
          assignLocalizedUrl
        />
      </Suspense>
      <HeaderLine />
    </>
  ) : null;
};
